import { SealCheck } from "@phosphor-icons/react";

import type { WorkspaceAccount } from "common/types";

import LicenseTag from "../AccountTags/LicenseTag";
import DetailItem from "./DetailItem";

interface SeatRowProps {
  license: WorkspaceAccount["license"];
  isRented: boolean;
}

export default function SeatRow({ license, isRented }: SeatRowProps) {
  return (
    <DetailItem label="Seat" icon={<SealCheck weight="fill" />}>
      <LicenseTag isRented={isRented} license={license} size="md" />
    </DetailItem>
  );
}
